// extracted by mini-css-extract-plugin
module.exports = {"main":"Screen_main__2nAkF","radio":"Screen_radio__3OqiM","play":"Screen_play__13tUc","pause":"Screen_pause__30YYq","prettyTime":"Screen_prettyTime__2igzm"};